import MapChart from './MapChart';
import ReactSimpleMap from './ReactSimpleMap';

export { ReactSimpleMap };

export default MapChart;
